<template>
  <BaseInput
    v-bind="$attrs"
    ref="goolemapsAutocomplete"
    v-model="innerValue"
    class="mb-2"
    style="z-index:9999px"
    placeholder="Address"
  />
</template>

<script lang="ts" setup>
import { Loader as GoogleMapsClient } from '@googlemaps/js-api-loader'
import { onMounted, ref, watch } from 'vue'
import BaseInput from './base/BaseInput.vue'


const props = defineProps({
  value: {
    type: null,
    default: null
  }
})

const emit = defineEmits(['input'])
const innerValue = ref(props.value)
const goolemapsAutocomplete = ref(null)

watch(() => props.value, (newVal) => {
  innerValue.value = newVal
})

watch(() => innerValue.value, (newVal) => {
  emit('input', newVal)
})

onMounted(async () => {
  const client = new GoogleMapsClient({
    apiKey: 'AIzaSyDGoGaWY583Na1LNmt_jhtPr0nw0D_xv0o',
    libraries: ['places'],
    region: 'US'
  })
  const input = goolemapsAutocomplete.value.$el
  const options = {
    componentRestrictions: { country: ['us'] },
    fields: ['formatted_address'],
    types: ['address']
  }
  const google = await client.load()

  const addressAutocomplete = new google.maps.places.Autocomplete(input, options)
  addressAutocomplete.addListener('place_changed', function () {
    const place = addressAutocomplete.getPlace()
    updateAddress(place.formatted_address)
  })
})


const updateAddress = (value) => {
  innerValue.value = value
}
</script>

<style lang="scss">
.pac-container {
  z-index: 9999;
}
</style>
